import colors from "./colors";

export default colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale/src/category20.js
// module id = 1121
// module chunks = 0